import React, { forwardRef } from 'react';
import classes from './info-hint.module.scss';
import classNames from 'classnames';
import { Icon } from './components/icon';
import { InfoHintProps, InfoHintType } from './info-hint.props';

const InfoHint = forwardRef<HTMLDivElement, InfoHintProps>(function InfoHint(
  { children, className, type = InfoHintType.Warning, iconSize = 16, iconColor, customIcon },
  ref
) {
  const spanSize = iconSize + 2;

  return (
    <div className={classNames(classes.offer, `${classes[`offer_${type}`]}`, className)} ref={ref}>
      <span
        style={{ width: spanSize, minWidth: spanSize, height: spanSize }}
        className={classNames('info-hint-icon', classes.icon)}
      >
        {customIcon ?? <Icon type={type} iconSize={iconSize} iconColor={iconColor} />}
      </span>

      <p className={classes.children}>{children}</p>
    </div>
  );
});

export default InfoHint;
